import React from "react";
import { Destination } from "../../../../../models";
import { formatDateUS } from "../../../../../utils";

export const DestinationCreatedColumn = ({
  destination,
}: {
  destination: Destination;
}) => {
  return (
    <div className="truncate overflow-hidden">
      {formatDateUS(destination["created_at"]!)}
    </div>
  );
};
